import {ChangesHistorySearch} from '../changes-history/models';
import {DocumentsSearch} from './models';

export class DocumentsState {
  filters: DocumentsSearch;
  changesHistoryFilters: ChangesHistorySearch;
}
